import { FormHelper } from './../../../../../../shared/form-helper';
import { ConfirmationService } from 'primeng/api';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { AcModel } from 'projects/core/src/lib/models/ac.model';
import { TemplateModel } from 'projects/core/src/lib/models/template.model';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { ResourceModel } from 'projects/core/src/lib/models/resource.model';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import {
  faStreetView,
  faUsers,
} from '@fortawesome/pro-light-svg-icons';
import { TranslocoService } from '@ngneat/transloco';
import { MorphModel } from 'projects/core/src/lib/models/morph.model';
import { FileHandlingComponent } from 'projects/admin/src/app/partials/data/file-handling/file-handling.component';

@Component({
  selector: 'app-ac-files',
  templateUrl: './ac-files.component.html',
  styleUrls: ['./ac-files.component.scss']
})
export class AcFilesComponent implements OnInit, OnChanges {

  @Input() ac: AcModel | TemplateModel = null;
  @Input() mode = 'ac';
  @Output() setEdit = new EventEmitter<string>();
  @ViewChild('filehandler') filehandler: FileHandlingComponent;

  public inEdit = false;
  public submitting = false;
  public editResource: ResourceModel = null;
  public form: UntypedFormGroup = this.fb.group({
    filename: new UntypedFormControl('', [Validators.required]),
    candidate: new UntypedFormControl(false),
    observer: new UntypedFormControl(false),
  });
  public ownerType: MorphModel = null;
  public files: Array<ResourceModel> = [];
  public inheritVisible = false;

  public faStreetView = faStreetView;
  public faUsers = faUsers;

  constructor(
    private api: ApiService,
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private confirmation: ConfirmationService,
    private transloco: TranslocoService,
    private auth: AuthStateService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ownerType = new MorphModel().deserialize({
      type: 'template.file',
      id: this.ac.id,
    });
    if (changes.ac) {
      this.mapFiles();
    }
  }

  onNew(): void {
    this.filehandler.openFileUpload();
  }

  onStartDelete(resource: ResourceModel): void {
    this.filehandler.onDeleteFile(this.ac.resources, resource);
  }

  onDelete(resources: Array<ResourceModel>): void {
    this.ac.resources = resources;
    this.mapFiles();
  }

  onDownload(resource: ResourceModel): void {
    this.filehandler.downloadFile(resource);
  }

  onFilesUpload(files: Array<ResourceModel>): void {
    files.forEach((file: ResourceModel) => {
      this.ac.resources.push(file);
    });
    this.mapFiles();
  }

  onSubmit(): void {
    if (this.ac !== null) {
      this.ui.hideMessage();
      if (this.form.valid === true) {
        if (this.ac?.shouldShowInheritDialog(this.mode)) {
          this.inheritVisible = true
        } else {
          this.saveChanges(false);
        }
      } else {
        this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
        FormHelper.markFormAsDirty(this.form);
      }
    }
  }

  saveChanges(inherit: boolean = false): void {
    this.submitting = true;
    const payload = {
      filename: this.addExtension(this.form.value.filename),
      candidate: this.form.value.candidate,
      observer: this.form.value.observer,
      inherit
    };
    this.api.saveModel('files', this.editResource.id, payload).subscribe({
      next: (result: any) => {
        this.editResource.public_name = result.data.public_name;
        this.editResource.permissions = result.data.permissions;
        this.ui.toastSuccess(this.transloco.translate('ac_files.filename_changed', { value: this.editResource.public_name }), this.transloco.translate('common.changed'));
        this.stopEdit();
      },
      error: (error: any) => {
        this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
      },
    }).add(() => {
      this.mapFiles();
      this.submitting = false;
    });
  }

  onEdit(resource: ResourceModel): void {
    if (this.auth.hasRight('admin.ac.edit')) {
      this.editResource = resource;
      this.startEdit();
    }
  }

  onCancel(): void {
    this.editResource = null;
    this.stopEdit();
  }

  startEdit(): void {
    this.form.patchValue({
      filename: this.deleteExtension(this.editResource.public_name),
      candidate: (this.editResource.permissions?.indexOf('candidate') !== -1),
      observer: (this.editResource.permissions?.indexOf('observer') !== -1),
    });
    this.inEdit = true;
    this.setEdit.emit('files');
  }

  stopEdit(): void {
    this.form.reset();
    this.inEdit = false;
    this.setEdit.emit(null);
  }

  private mapFiles(): void {
    this.files = this.ac.resources.filter(resource => resource.type === 'template.file');
  }

  private deleteExtension(filename: string): string {
    return filename.replace(/\..*$/gm, '');
  }

  private addExtension(filename: string): string {
    return filename + this.editResource.public_name.match(/\..*$/gm)[0];
  }

}
